import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaPlus, FaUpload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

interface ICreateModule {
  lineData: Record<string, any>;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

export default function CreateModule({
  lineData
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const { projectHash, eventHash } = useParams<IParams>()
  const key = uuid();

  const updateList = async (data) => {


    const items: Array<Record<string, any>> = [];

    data?.map(item => {

      items?.push({ name: item?.NOME, email: item?.['E-MAIL'], bcc: item?.['CÓPIA'] });

    })
    try {
      await api.put(`/mailer-campaign/${lineData?._id?.toString()}/list`, { list: items });
      addToast({ title: 'Atualizado com sucesso', type: 'success' });
      removeModal('confirm');
      await reloadSearchAll();
    }
    catch (err) {
      addToast({ title: 'Erro ao atualizar', type: 'error' })
    }

  }

  const setCallback = async (
    data: Record<string, any>,
    formRef: React.RefObject<FormHandles>,
  ): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('file', data.image)
      const response = await api.post(`/converter/xlsx-to-json`, formData);

      if (response.status !== 200) {
        return addToast({ type: 'error', title: 'Erro ao salvar' });
      }



      addModal({
        key: 'confirm',
        theme: 'whiteModal',
        title: '', content: <>
          <button onClick={() => updateList(response?.data?.rows)} className='defaultButton'>Confirmar</button>

          <table className='tableRef'>
            <tbody>
              <tr><td>NOME</td><td>E-MAIL</td><td>Cópia oculta</td></tr>
              {response?.data?.rows?.map(item => {
                return <tr><td>{item?.NOME}</td><td>{item?.["E-MAIL"]}</td><td>{item?.["CÓPIA"]}</td></tr>
              })}
            </tbody>

          </table>


        </>
      })

      removeModal(key);


    } catch (err) {
      console.log(err)
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
        return;
      }

      return addToast({ type: 'error', title: err?.response?.data?.error || err?.response?.data?.message });
    }
  };

  const handleCreate = (): void => {
    const content = (
      <FormComponent schema={{
        image: {
          model: 'uploadImage',
          type: 'upload',
          name: 'image',
          label: 'Lista de contatos',
        }
      }} setCallback={setCallback} />
    );
    if (content) {
      const keyModal = addModal({ title: 'Adicionar contatos', content, key, theme: "whiteModal" });
    }
  };

  const moduleCreate = (): JSX.Element => (
    lineData._id ? <button className="lineIcon" type="button" onClick={handleCreate}>
      <FaUpload />
    </button> : <></>
  );

  return moduleCreate();
}
